module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside_hvid_2.267a2393.svg";